import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { light } from "./palette";

let theme = createTheme({
  typography: {
    // Global font settings
    fontFamily:
      "'SpaceGrotesk-Bold', 'SpaceGrotesk-Light', 'SpaceGrotesk-Medium', 'SpaceGrotesk-Regular', 'SpaceGrotesk-SemiBold', sans-serif",
    fontSize: 14, // base font size

    h1: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "56px",
      color: light.text.header,
      whiteSpace: "normal",
    },
    h1Italic: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "56px",
    },
    h2: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "48px",
      color: light.text.header2,
    },
    h3: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "36px",
      color: light.text.header2,
    },
    h4: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "30px",
      color: light.text.header2,
    },
    h5: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "24px",
      color: light.text.description2,
    },
    h6: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "20px",
      color: light.text.header2,
    },
    h6extraBold: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "18px",
      color: light.text.description2,
    },
    faq: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "24px",
      color: light.text.header2,
    },
    pricingTitle: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "32px",
      color: light.text.pricing,
    },
    pricingPrice: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "60px",
      color: light.text.pricing,
    },
    caption: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "12px",
      color: light.text.pricing,
    },
    caption2: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "16px",
      color: light.text.caption,
    },
    navLink: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "16px",
      color: light.text.header2,
    },
    radioBtnText: {
      fontFamily: "'SpaceGrotesk-Medium', sans-serif",
      fontSize: "20px",
      color: light.text.radioBtn,
    },
    blogText: {
      fontFamily: "'SpaceGrotesk-Medium', sans-serif",
      fontSize: "20px",
      color: "#000000DE",
    },
    body1: {
      fontFamily: "'SpaceGrotesk-Regular', sans-serif",
      fontSize: "16px",
      color: light.text.body1,
    },
    body2: {
      fontFamily: "'SpaceGrotesk-Regular', sans-serif",
      fontSize: "12px",
    },
    footer: {
      fontFamily: "'SpaceGrotesk-Regular', sans-serif",
      fontSize: "15px",
      color: light.text.light,
    },
    description: {
      fontFamily: "'SpaceGrotesk-Medium', sans-serif",
      fontSize: "20px",
      color: light.text.description,
      whiteSpace: "normal",
    },
    description2: {
      fontFamily: "'SpaceGrotesk-Medium', sans-serif",
      fontSize: "16px",
      color: light.text.description2,
      whiteSpace: "normal",
    },
    titleExtraBold: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "40px",
      color: light.text.pricing,
    },
    title: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "30px",
      color: light.text.header2,
    },
    title1: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "24px",
      color: light.text.header2,
    },
    title2: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "20px",
      color: light.text.header2,
    },
    title3: {
      fontFamily: "'SpaceGrotesk-Bold', sans-serif",
      fontSize: "16px",
      color: light.text.header2,
    },
    subtitle1: {
      fontFamily: "'SpaceGrotesk-Medium', sans-serif",
      fontSize: "24px",
      color: light.text.description2,
      whiteSpace: "normal",
    },
    subtitle2: {
      fontFamily: "'SpaceGrotesk-Medium', sans-serif",
      fontSize: "20px",
      color: light.text.description2,
      whiteSpace: "normal",
    },
    subtitle3: {
      fontFamily: "'SpaceGrotesk-Medium', sans-serif",
      fontSize: "16px",
      color: light.text.description2,
      whiteSpace: "normal",
    },
    subtitleLight: {
      fontFamily: "'SpaceGrotesk-Light', sans-serif",
      fontSize: "10px",
      color: light.text.description,
      whiteSpace: "normal",
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
